import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";

import RoleTableRow from "../RoleTableRow";
import type { Role } from "../types";

interface RolesTableProps {
    roles: Role[];
    onEditRole: (role: Role) => void;
}

const RolesTable = ({ roles, onEditRole }: RolesTableProps) => {
    const [t] = useTranslation();

    return (
        <TableContainer
            component={Paper}
            sx={{
                borderRadius: "8px",
                border: "1px solid var(--border-grey, #e5e5e5)",
                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
            }}
        >
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <strong>{t("Roles.Role")}</strong>
                        </TableCell>
                        <TableCell>
                            <strong>{t("Roles.Brands")}</strong>
                        </TableCell>
                        <TableCell>
                            <strong>{t("Roles.ContractTypes")}</strong>
                        </TableCell>
                        <TableCell>
                            <strong>{t("Roles.Users")}</strong>
                        </TableCell>
                        <TableCell>
                            <strong>{t("Roles.Type")}</strong>
                        </TableCell>
                        <TableCell align="right">
                            <strong>{t("Roles.Actions")}</strong>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {roles.map((role) => (
                        <RoleTableRow key={role.id} role={role} onEdit={onEditRole} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default RolesTable;
